var _defs, _g, _g2, _g3, _path, _path2, _path3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 37.5 37.499999",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "47b407e91f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.941406 9.480469 L 25.558594 9.480469 L 25.558594 23.09375 L 11.941406 23.09375 Z M 11.941406 9.480469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aee4ae68cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.75 9.480469 C 14.988281 9.480469 11.941406 12.527344 11.941406 16.289062 C 11.941406 20.046875 14.988281 23.09375 18.75 23.09375 C 22.511719 23.09375 25.558594 20.046875 25.558594 16.289062 C 25.558594 12.527344 22.511719 9.480469 18.75 9.480469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f121422d22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.125 12.378906 L 22.625 12.378906 L 22.625 16 L 15.125 16 Z M 15.125 12.378906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "50b14e8280"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.125 16 L 22 16 L 22 19.878906 L 15.125 19.878906 Z M 15.125 16 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e7ab7022af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.902344 14.765625 L 19.59375 14.765625 L 19.59375 15.457031 L 18.902344 15.457031 Z M 18.902344 14.765625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e55283dfda"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.90625 14.765625 L 18.597656 14.765625 L 18.597656 15.457031 L 17.90625 15.457031 Z M 17.90625 14.765625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a2e75e4161"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.902344 15.773438 L 19.59375 15.773438 L 19.59375 16.460938 L 18.902344 16.460938 Z M 18.902344 15.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "512cef1178"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.90625 15.773438 L 18.597656 15.773438 L 18.597656 16.460938 L 17.90625 16.460938 Z M 17.90625 15.773438 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#47b407e91f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aee4ae68cc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 11.941406 9.480469 L 25.558594 9.480469 L 25.558594 23.09375 L 11.941406 23.09375 Z M 11.941406 9.480469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f121422d22)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 22.558594 15.648438 L 19.003906 12.445312 C 18.933594 12.382812 18.824219 12.382812 18.757812 12.445312 L 15.203125 15.648438 C 15.132812 15.710938 15.128906 15.816406 15.199219 15.878906 C 15.265625 15.945312 15.378906 15.945312 15.445312 15.882812 L 18.878906 12.789062 L 22.3125 15.882812 C 22.347656 15.914062 22.390625 15.929688 22.4375 15.929688 C 22.480469 15.929688 22.527344 15.914062 22.5625 15.878906 C 22.628906 15.816406 22.628906 15.710938 22.558594 15.648438 Z M 22.558594 15.648438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#50b14e8280)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.785156 16.71875 C 21.6875 16.71875 21.609375 16.789062 21.609375 16.882812 L 21.609375 19.257812 C 21.609375 19.421875 21.464844 19.554688 21.285156 19.554688 L 16.472656 19.554688 C 16.296875 19.554688 16.152344 19.421875 16.152344 19.257812 L 16.152344 16.882812 C 16.152344 16.789062 16.074219 16.71875 15.976562 16.71875 C 15.878906 16.71875 15.800781 16.789062 15.800781 16.882812 L 15.800781 19.257812 C 15.800781 19.601562 16.101562 19.882812 16.472656 19.882812 L 21.285156 19.882812 C 21.660156 19.882812 21.960938 19.601562 21.960938 19.257812 L 21.960938 16.882812 C 21.960938 16.789062 21.882812 16.71875 21.785156 16.71875 Z M 21.785156 16.71875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.969697, 0, 0, 0.75, 20.141301, 12.76809)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.498814 0.501921 L 1.058751 0.501921 ",
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.000000000000000059, -0.969697, 0.75, 0.000000000000000046, 19.93751, 14.190293)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.498364 0.499986 L 1.0583 0.499986 ",
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.000000000000000052, -0.857143, 0.75, 0.000000000000000046, 20.84342, 14.998163)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.499159 0.50044 L 2.130669 0.50044 ",
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7ab7022af)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 18.902344 14.765625 L 19.59375 14.765625 L 19.59375 15.457031 L 18.902344 15.457031 Z M 18.902344 14.765625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e55283dfda)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.90625 14.765625 L 18.597656 14.765625 L 18.597656 15.457031 L 17.90625 15.457031 Z M 17.90625 14.765625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a2e75e4161)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 18.902344 15.773438 L 19.59375 15.773438 L 19.59375 16.464844 L 18.902344 16.464844 Z M 18.902344 15.773438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#512cef1178)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.90625 15.773438 L 18.597656 15.773438 L 18.597656 16.464844 L 17.90625 16.464844 Z M 17.90625 15.773438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.588176, 26.262944)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.722656 -1.746094 L 1.109375 -0.378906 L 0.5 -1.746094 L 0.191406 -1.746094 L 0.191406 0 L 0.476562 0 L 0.476562 -1.203125 L 1.011719 0 L 1.203125 0 L 1.746094 -1.207031 L 1.746094 0 L 2.027344 0 L 2.027344 -1.746094 Z M 1.722656 -1.746094 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.043108, 26.262944)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.023438 0.0234375 C 1.519531 0.0234375 1.917969 -0.378906 1.917969 -0.875 C 1.917969 -1.367188 1.519531 -1.769531 1.023438 -1.769531 C 0.527344 -1.769531 0.125 -1.367188 0.125 -0.875 C 0.125 -0.378906 0.527344 0.0234375 1.023438 0.0234375 Z M 1.023438 -0.257812 C 0.679688 -0.257812 0.40625 -0.527344 0.40625 -0.875 C 0.40625 -1.21875 0.679688 -1.488281 1.023438 -1.488281 C 1.367188 -1.488281 1.636719 -1.21875 1.636719 -0.875 C 1.636719 -0.527344 1.367188 -0.257812 1.023438 -0.257812 Z M 1.023438 -0.257812 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.32327, 26.262944)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.191406 0 L 0.714844 0 C 1.199219 0 1.589844 -0.390625 1.589844 -0.875 C 1.589844 -1.355469 1.199219 -1.746094 0.714844 -1.746094 L 0.191406 -1.746094 Z M 0.476562 -0.265625 L 0.476562 -1.484375 L 0.714844 -1.484375 C 1.046875 -1.484375 1.308594 -1.222656 1.308594 -0.875 C 1.308594 -0.523438 1.046875 -0.265625 0.714844 -0.265625 Z M 0.476562 -0.265625 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.274282, 26.262944)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.207031 -1.488281 L 1.207031 -1.746094 L 0.207031 -1.746094 L 0.207031 0 L 1.207031 0 L 1.207031 -0.257812 L 0.492188 -0.257812 L 0.492188 -0.742188 L 1.113281 -0.742188 L 1.113281 -1.003906 L 0.492188 -1.003906 L 0.492188 -1.488281 Z M 1.207031 -1.488281 "
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.867017, 26.262944)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.003906 -0.761719 C 1.21875 -0.808594 1.378906 -1 1.378906 -1.234375 C 1.378906 -1.519531 1.160156 -1.746094 0.875 -1.746094 L 0.191406 -1.746094 L 0.191406 0 L 0.476562 0 L 0.476562 -0.734375 L 0.71875 -0.734375 L 1.183594 0 L 1.503906 0 Z M 0.476562 -0.980469 L 0.476562 -1.484375 L 0.84375 -1.484375 C 0.992188 -1.484375 1.101562 -1.378906 1.101562 -1.230469 C 1.101562 -1.082031 0.992188 -0.980469 0.84375 -0.980469 Z M 0.476562 -0.980469 "
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.611218, 26.262944)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.449219 -1.746094 L 1.449219 -0.453125 L 0.476562 -1.746094 L 0.191406 -1.746094 L 0.191406 0 L 0.476562 0 L 0.476562 -1.300781 L 1.445312 0 L 1.730469 0 L 1.730469 -1.746094 Z M 1.449219 -1.746094 "
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.769042, 26.262944)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.703477, 26.262944)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.3125 -1.746094 L 1.3125 -1.007812 L 0.476562 -1.007812 L 0.476562 -1.746094 L 0.191406 -1.746094 L 0.191406 0 L 0.476562 0 L 0.476562 -0.742188 L 1.3125 -0.742188 L 1.3125 0 L 1.597656 0 L 1.597656 -1.746094 Z M 1.3125 -1.746094 "
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.730224, 26.262944)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.023438 0.0234375 C 1.519531 0.0234375 1.917969 -0.378906 1.917969 -0.875 C 1.917969 -1.367188 1.519531 -1.769531 1.023438 -1.769531 C 0.527344 -1.769531 0.125 -1.367188 0.125 -0.875 C 0.125 -0.378906 0.527344 0.0234375 1.023438 0.0234375 Z M 1.023438 -0.257812 C 0.679688 -0.257812 0.40625 -0.527344 0.40625 -0.875 C 0.40625 -1.21875 0.679688 -1.488281 1.023438 -1.488281 C 1.367188 -1.488281 1.636719 -1.21875 1.636719 -0.875 C 1.636719 -0.527344 1.367188 -0.257812 1.023438 -0.257812 Z M 1.023438 -0.257812 "
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.010385, 26.262944)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.875 0.0234375 C 1.269531 0.0234375 1.566406 -0.230469 1.566406 -0.566406 L 1.566406 -1.746094 L 1.28125 -1.746094 L 1.28125 -0.617188 C 1.28125 -0.402344 1.105469 -0.242188 0.875 -0.242188 C 0.640625 -0.242188 0.46875 -0.402344 0.46875 -0.617188 L 0.46875 -1.746094 L 0.183594 -1.746094 L 0.183594 -0.566406 C 0.183594 -0.230469 0.476562 0.0234375 0.875 0.0234375 Z M 0.875 0.0234375 "
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.996352, 26.262944)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.679688 0.0234375 C 0.992188 0.0234375 1.25 -0.164062 1.25 -0.476562 C 1.25 -1.097656 0.421875 -0.945312 0.421875 -1.304688 C 0.421875 -1.441406 0.53125 -1.507812 0.660156 -1.507812 C 0.773438 -1.507812 0.878906 -1.453125 0.957031 -1.355469 L 1.160156 -1.539062 C 1.046875 -1.675781 0.863281 -1.769531 0.660156 -1.769531 C 0.382812 -1.769531 0.136719 -1.597656 0.136719 -1.285156 C 0.136719 -0.703125 0.964844 -0.847656 0.964844 -0.476562 C 0.964844 -0.335938 0.84375 -0.25 0.679688 -0.25 C 0.503906 -0.25 0.371094 -0.347656 0.308594 -0.5 L 0.0625 -0.347656 C 0.167969 -0.132812 0.398438 0.0234375 0.679688 0.0234375 Z M 0.679688 0.0234375 "
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.554133, 26.262944)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.207031 -1.488281 L 1.207031 -1.746094 L 0.207031 -1.746094 L 0.207031 0 L 1.207031 0 L 1.207031 -0.257812 L 0.492188 -0.257812 L 0.492188 -0.742188 L 1.113281 -0.742188 L 1.113281 -1.003906 L 0.492188 -1.003906 L 0.492188 -1.488281 Z M 1.207031 -1.488281 "
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.282064, 27.801898)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.351562 -0.320312 C 0.445312 -0.328125 0.515625 -0.40625 0.515625 -0.503906 C 0.515625 -0.609375 0.429688 -0.691406 0.328125 -0.691406 L 0.0898438 -0.691406 L 0.0898438 0 L 0.144531 0 L 0.144531 -0.316406 L 0.296875 -0.316406 L 0.496094 0 L 0.558594 0 Z M 0.144531 -0.371094 L 0.144531 -0.636719 L 0.324219 -0.636719 C 0.398438 -0.636719 0.460938 -0.578125 0.460938 -0.503906 C 0.460938 -0.425781 0.398438 -0.371094 0.324219 -0.371094 Z M 0.144531 -0.371094 "
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.999023, 27.801898)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.464844 -0.636719 L 0.464844 -0.691406 L 0.09375 -0.691406 L 0.09375 0 L 0.464844 0 L 0.464844 -0.0546875 L 0.152344 -0.0546875 L 0.152344 -0.320312 L 0.425781 -0.320312 L 0.425781 -0.371094 L 0.152344 -0.371094 L 0.152344 -0.636719 Z M 0.464844 -0.636719 "
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.679099, 27.801898)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.507812 0 L 0.566406 0 L 0.316406 -0.691406 L 0.257812 -0.691406 L 0.00390625 0 L 0.0664062 0 L 0.125 -0.167969 L 0.449219 -0.167969 Z M 0.144531 -0.21875 L 0.285156 -0.625 L 0.429688 -0.21875 Z M 0.144531 -0.21875 "
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.394905, 27.801898)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.144531 -0.0546875 L 0.144531 -0.691406 L 0.0898438 -0.691406 L 0.0898438 0 L 0.410156 0 L 0.410156 -0.0546875 Z M 0.144531 -0.0546875 "
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.959718, 27.801898)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.386218, 27.801898)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.464844 -0.636719 L 0.464844 -0.691406 L 0.09375 -0.691406 L 0.09375 0 L 0.464844 0 L 0.464844 -0.0546875 L 0.152344 -0.0546875 L 0.152344 -0.320312 L 0.425781 -0.320312 L 0.425781 -0.371094 L 0.152344 -0.371094 L 0.152344 -0.636719 Z M 0.464844 -0.636719 "
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.066294, 27.801898)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.261719 0.0078125 C 0.371094 0.0078125 0.472656 -0.0546875 0.472656 -0.175781 C 0.472656 -0.40625 0.125 -0.351562 0.125 -0.527344 C 0.125 -0.609375 0.191406 -0.644531 0.261719 -0.644531 C 0.316406 -0.644531 0.367188 -0.617188 0.394531 -0.582031 L 0.4375 -0.617188 C 0.402344 -0.664062 0.335938 -0.699219 0.257812 -0.699219 C 0.160156 -0.699219 0.0703125 -0.636719 0.0703125 -0.527344 C 0.0703125 -0.304688 0.417969 -0.355469 0.417969 -0.175781 C 0.417969 -0.09375 0.347656 -0.046875 0.261719 -0.046875 C 0.175781 -0.046875 0.117188 -0.09375 0.0898438 -0.15625 L 0.0390625 -0.128906 C 0.0742188 -0.046875 0.15625 0.0078125 0.261719 0.0078125 Z M 0.261719 0.0078125 "
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.721011, 27.801898)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.460938 -0.691406 L 0.015625 -0.691406 L 0.015625 -0.636719 L 0.210938 -0.636719 L 0.210938 0 L 0.265625 0 L 0.265625 -0.636719 L 0.460938 -0.636719 Z M 0.460938 -0.691406 "
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.342303, 27.801898)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.507812 0 L 0.566406 0 L 0.316406 -0.691406 L 0.257812 -0.691406 L 0.00390625 0 L 0.0664062 0 L 0.125 -0.167969 L 0.449219 -0.167969 Z M 0.144531 -0.21875 L 0.285156 -0.625 L 0.429688 -0.21875 Z M 0.144531 -0.21875 "
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.058109, 27.801898)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.460938 -0.691406 L 0.015625 -0.691406 L 0.015625 -0.636719 L 0.210938 -0.636719 L 0.210938 0 L 0.265625 0 L 0.265625 -0.636719 L 0.460938 -0.636719 Z M 0.460938 -0.691406 "
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.6794, 27.801898)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.464844 -0.636719 L 0.464844 -0.691406 L 0.09375 -0.691406 L 0.09375 0 L 0.464844 0 L 0.464844 -0.0546875 L 0.152344 -0.0546875 L 0.152344 -0.320312 L 0.425781 -0.320312 L 0.425781 -0.371094 L 0.152344 -0.371094 L 0.152344 -0.636719 Z M 0.464844 -0.636719 "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.5fa67c4952c716861a734563dff398b4.svg";
export { ForwardRef as ReactComponent };